module.exports = __webpack_public_path__ + "img/start_t.4e94f9bd.svg";